(function () {
    'use strict';

    angular.module("imApp").factory("valutaService", ['$ihttp', function ($ihttp) {
        let service = {
            getValutaEdit: function (parms) {
                return $ihttp.post({
                    method: 656,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 743,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
